import React from 'react';
import { Trans } from 'react-i18next';
import classnames from 'classnames';
import { observer } from 'mobx-react';
import { useStore } from '../../../store/rootStore';
import Logo from '../../../assets/logos/texterLogos/texter-logo-square2-192x192.png';
import LanguageSelect from '../../SettingsDrawer/components/LanguageSelect';
import s from '../Login.module.scss';
const LoginLayout = ({ children, errorMessage }) => {
    const { partnerTheme } = useStore();
    return (React.createElement("div", { className: s.container },
        React.createElement("div", { className: s.content },
            React.createElement("div", { className: s.topBar },
                React.createElement("div", { className: s.topBarContent },
                    React.createElement("img", { className: classnames(s.logo, {
                            [s.custom]: !!partnerTheme,
                        }), src: partnerTheme ? partnerTheme.icon : Logo, alt: "Logo" }),
                    React.createElement("div", { className: s.centralTextBlock },
                        React.createElement("div", { className: s.mainText }, partnerTheme ? (React.createElement(Trans, { i18nKey: "loginTo", values: { name: partnerTheme.name } })) : (React.createElement(Trans, { i18nKey: "loginToTexterchat" })))),
                    React.createElement(LanguageSelect, { className: s.languageSelect }))),
            children,
            React.createElement("div", { className: s.bottomBar },
                React.createElement("div", { className: s.messagesBlock }, errorMessage ? (React.createElement("p", { className: classnames(s.notificationText, s.loginError) }, errorMessage)) : null),
                React.createElement("p", { className: s.termsAndPrivacy },
                    React.createElement(Trans, { i18nKey: "termsAndPrivacy", components: {
                            1: React.createElement("a", { href: "https://texterchat.com/terms", target: "_blank", rel: "noopener noreferrer" }),
                            2: React.createElement("a", { href: "https://texterchat.com/privacy", target: "_blank", rel: "noopener noreferrer" }),
                        } })),
                window.ReactNativeWebView && (React.createElement("a", { className: s.linkButton, onClick: () => {
                        window.ReactNativeWebView.postMessage(JSON.stringify({
                            event: 'goToProjectSelect',
                        }));
                    } },
                    React.createElement(Trans, { i18nKey: "changeProject" })))))));
};
export default observer(LoginLayout);
